import { BaseService } from './BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { CheckBlackListRequest } from './service-models/check-black-list/CheckBlackListRequest';
import { CheckBlackListResult } from './service-models/check-black-list/CheckBlackListResult';

/**
 * ブラックリスト入り判定サービス
 */
export class BlackListService extends BaseService {
	// サービス メソッド  -----------------------------------------------------------------------------------------------------------------------------
	/**
	 * ブラックリスト入り判定
	 * @param viewCore ビュー情報 
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public checkBlackList(viewCore: WprBaseViewCore, request: CheckBlackListRequest, resMethod: (result: CheckBlackListResult) => void): void {
		return this.doPost(viewCore, '/blacklist/check', request, resMethod);
	}
	// -----------------------------------------------------------------------------------------------------------------------------------------------
}